import { fromJS, List as ImmutableList } from 'immutable';
import memoize from 'transmute/memoize';
const TEAM_ID_INDEX = 2;
const HAS_TEAM_ID = 3;
export const populateChildTeams = teams => {
  let teamsMap = teams;
  teamsMap.forEach((team, id) => {
    const parentTeamId = team.get('parentTeamId');
    if (parentTeamId) {
      const childTeams = teamsMap.getIn([parentTeamId, 'childTeams'], ImmutableList()).push(id);
      teamsMap = teamsMap.setIn([parentTeamId, 'childTeams'], childTeams);
    }
  });
  return teamsMap;
};
export const deriveNestedTeamIds = (parentId, teams) => {
  if (parentId) {
    const teamIds = [parentId];
    const childTeams = teams.getIn([parentId, 'childTeams'], ImmutableList());
    childTeams.forEach(id => teamIds.push(...deriveNestedTeamIds(id, teams)));
    return teamIds;
  }
  return [];
};
export const deriveBreadcrumbPath = memoize((teams, selectedTeamId) => {
  let parentId = selectedTeamId;
  const breadcrumbPath = [];
  while (parentId) {
    breadcrumbPath.unshift({
      title: teams.getIn([parentId, 'name']),
      id: parentId
    });
    // Ensures that even if the team has a parent id, we treat it as final if that parent id doesn't exist in our team map due to permissions
    parentId = teams.getIn([teams.getIn([parentId, 'parentTeamId']), 'id'], null);
  }
  return fromJS(breadcrumbPath);
});
export const getTeamIdFromUrl = location => {
  if (!location) {
    return null;
  }
  const urlParams = location.pathname.split('/');
  const hasId = urlParams.length === HAS_TEAM_ID;
  if (hasId) {
    return urlParams[TEAM_ID_INDEX];
  }
  return null;
};
export const getUserIdsInTeam = (teams, team) => {
  if (!team.get('childTeams').size) {
    return team.get('userIds');
  }
  const teamUserIds = team.get('userIds');
  const childTeamsUserIds = team.get('childTeams').reduce((acc, childTeam) => {
    const childTeamObj = teams.get(childTeam);
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return acc.concat(getUserIdsInTeam(teams, childTeamObj)).toList();
  }, ImmutableList());
  return teamUserIds.concat(childTeamsUserIds).toList();
};
export const getUserIdsInViewableTeams = (teams, viewableTeams) => {
  return viewableTeams.map(teamId => {
    const team = teams.get(teamId);
    return getUserIdsInTeam(teams, team);
  }).reduce( /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  (acc, userIds) => acc.concat(userIds).toList(), ImmutableList());
};
export const sortTeamsAlphabetically = teams => teams.sort((a, b) => a === null || a === void 0 ? void 0 : a.get('name').localeCompare(b === null || b === void 0 ? void 0 : b.get('name'))).toList();